import { Box, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { DATE_FORMAT } from "@constants";
import {
    ETimeSlot,
    IAvailableAppointmentDate,
} from "@modules/eirCustomersFacade/interfaces/models/IAvailableAppointmentDate";
import { useAppointmentRescheduledModalContent } from "@features/Appointment/AppointmentRescheduleModal/useAppointmentRescheduledModalContent";
import { EInstallationType } from "@modules/eirCustomersFacade/interfaces/models/IAppointment";
import { useTranslation } from "react-i18next";
import { useStyle } from "@features/Appointment/AppointmentRescheduleModal/style";
import { CalendarIcon } from "@common/Icon/CalendarIcon/CalendarIcon";

interface IParams {
    availableAppointmentList: IAvailableAppointmentDate[];
    appointmentInstallationType: EInstallationType;
    dateValue: string;
    setDateValue(date: string): void;
    timeSlotValue: ETimeSlot;
    setTimeSlotValue(timeSlot: ETimeSlot): void;
}

export const AppointmentRescheduleModalContent = (props: IParams) => {
    const {
        availableAppointmentList,
        appointmentInstallationType,
        dateValue,
        setDateValue,
        timeSlotValue,
        setTimeSlotValue,
    } = props;
    const { t } = useTranslation("appointment");
    const { classes } = useStyle();

    const {
        isMobile,
        isTechInstallation,
        shouldDisableDate,
        handleDateChange,
        handleTimeSlotChange,
        timeSlotAvailableListForDate,
    } = useAppointmentRescheduledModalContent({
        appointmentInstallationType,
        availableAppointmentList,
        dateValue,
        setDateValue,
        setTimeSlotValue,
    });

    return (
        <Stack spacing={2}>
            <Typography color="secondary" variant="normal">
                {t("rescheduleModalContentDetails")}
            </Typography>
            <Stack alignItems={isMobile ? "stretch" : "center"} flexDirection={isMobile ? "column" : "row"} gap={2}>
                <Box
                    flex={isTechInstallation ? 1 : undefined}
                    width={isMobile ? "100%" : isTechInstallation ? undefined : "50%"}
                >
                    <DatePicker
                        className={classes.datePicker}
                        components={{
                            OpenPickerIcon: CalendarIcon,
                        }}
                        inputFormat={DATE_FORMAT}
                        renderInput={(params) => (
                            <TextField
                                // eslint-disable-next-line react/jsx-props-no-spreading
                                {...params}
                                fullWidth
                                inputProps={{
                                    ...params.inputProps,
                                    className: classes.datePickerInput,
                                    readOnly: true,
                                    "aria-label": "reschedule-appointment-datepicker",
                                }}
                            />
                        )}
                        shouldDisableDate={shouldDisableDate}
                        value={dateValue}
                        onChange={handleDateChange}
                    />
                </Box>
                {isTechInstallation && (
                    <Box flex={1} width={isMobile ? "100%" : undefined}>
                        <Select
                            aria-label={t("timeSlotLabel")}
                            data-testid={"reschedule-time-slot-select"}
                            disableUnderline
                            fullWidth
                            id={"reschedule-time-slot-select"}
                            value={timeSlotValue}
                            variant="filled"
                            onChange={handleTimeSlotChange}
                        >
                            {timeSlotAvailableListForDate.map((timeSlot) => (
                                <MenuItem key={timeSlot} value={timeSlot}>
                                    {timeSlot}
                                </MenuItem>
                            ))}
                        </Select>
                    </Box>
                )}
            </Stack>
            {isTechInstallation && (
                <Stack spacing={1}>
                    <Typography color="secondary" fontWeight={"bold"} variant="large">
                        {t("rescheduleTechInstallModalSubtitle")}
                    </Typography>
                    <Typography color="secondary" variant="normal">
                        {t("rescheduleTechInstallModalDetails")}
                    </Typography>
                </Stack>
            )}
        </Stack>
    );
};
